import { render } from "./SearchIcon.vue?vue&type=template&id=c22f8c7e&scoped=true"
import script from "./SearchIcon.vue?vue&type=script&lang=js"
export * from "./SearchIcon.vue?vue&type=script&lang=js"

import "./SearchIcon.vue?vue&type=style&index=0&id=c22f8c7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c22f8c7e"]])

export default __exports__